import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { ModelBroker } from '../dashboard/Models';
import { CoolWriteStore } from '../packages/voting/VotingViewState';
import { createScope } from '../Scope';

const ssoTemplate = {
    entryPoint: '',
    issuer: '',
    certificate: '',
    domains: '',
    required: false,
};

export class ManageSingleSignOnModel extends CoolWriteStore(ssoTemplate) {

    public readonly id = '$';

    public static create(_broker: ModelBroker) {
        return new ManageSingleSignOnModel();
    }

    public reset() {
        this.mutateTo(ssoTemplate);
    }
}

export const ManageSingleSignOnScope = createScope({
    async refresh(p, c) {
        const api = c.get(ApiClient);
        const broker = c.get(ModelBroker);

        const data = await api.exec(v2.admin.sso.info());
        const model = broker.allocate(ManageSingleSignOnModel);
        model.updateTo(data);

        c.bind(ManageSingleSignOnModel).toConstantValue(model);

        return [
        ];
    }
});
